"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMuiAlert = getMuiAlert;
function getMuiAlert(palette) {
  return {
    defaultProps: {
      // @ts-ignore missing in defaultProps type
      'data-testid': 'required'
    },
    styleOverrides: {
      filled: {
        '&.MuiAlert-standardError': {
          backgroundColor: palette.error.main
        },
        '&.MuiAlert-standardSuccess': {
          backgroundColor: palette.success.main
        },
        '&.MuiAlert-standardWarning': {
          backgroundColor: palette.warning.main
        },
        '.MuiAlert-action': {
          '.MuiSvgIcon-root': {
            color: palette.common.white
          }
        },
        '.MuiAlert-icon': {
          color: palette.common.white,
          fontSize: 24,
          marginRight: 18.67
        },
        '.MuiAlert-message': {
          color: palette.common.white
        },
        alignItems: 'center',
        justifyContent: 'center'
      },
      root: {
        '&.MuiAlert-inline': {
          '.MuiAlert-action': {
            padding: '0px'
          },
          '.MuiLink-root': {
            marginRight: '32px'
          },
          alignItems: 'center'
        },
        '&.MuiAlert-inlineAttention': {
          '.MuiAlert-message': {
            color: palette.attention.main
          },
          '.MuiLink-root': {
            color: palette.attention.main
          },
          '.MuiSvgIcon-root': {
            color: palette.attention.main
          },
          backgroundColor: palette.attention.light
        },
        '&.MuiAlert-inlineError': {
          '.MuiAlert-message': {
            color: palette.error[700]
          },
          '.MuiLink-root': {
            color: palette.error[700]
          },
          '.MuiSvgIcon-root': {
            color: palette.error[700]
          },
          backgroundColor: palette.error.light
        },
        '&.MuiAlert-inlineInfo': {
          '.MuiAlert-message': {
            color: palette.info.dark
          },
          '.MuiLink-root': {
            color: palette.info.dark
          },
          '.MuiSvgIcon-root': {
            color: palette.info.dark
          },
          backgroundColor: palette.primary[50]
        },
        '&.MuiAlert-inlineSuccess': {
          '.MuiAlert-message': {
            color: palette.success[900]
          },
          '.MuiLink-root': {
            color: palette.success[900]
          },
          '.MuiSvgIcon-root': {
            color: palette.success[900]
          },
          backgroundColor: palette.success.light
        },
        '&.MuiAlert-inlineWarning': {
          '.MuiAlert-message': {
            color: palette.warning.main
          },
          '.MuiLink-root': {
            color: palette.warning.main
          },
          '.MuiSvgIcon-root': {
            color: palette.warning.main
          },
          backgroundColor: palette.warning.light
        },
        '&.MuiAlert-standard': {
          alignItems: 'center',
          minHeight: '40px'
        },
        '&.MuiAlert-standardAttention': {
          '.MuiAlert-message': {
            color: palette.attention.main
          },
          '.MuiLink-root': {
            color: palette.attention.main
          },
          '.MuiSvgIcon-root': {
            color: palette.attention.main
          },
          backgroundColor: palette.attention.light
        },
        '&.MuiAlert-standardError': {
          '.MuiAlert-message': {
            color: palette.error[700]
          },
          '.MuiLink-root': {
            color: palette.error[700]
          },
          '.MuiSvgIcon-root': {
            color: palette.error[700]
          },
          backgroundColor: palette.error.light
        },
        '&.MuiAlert-standardInfo': {
          '.MuiAlert-message': {
            color: palette.info.dark
          },
          '.MuiLink-root': {
            color: palette.info.dark
          },
          '.MuiSvgIcon-root': {
            color: palette.info.dark
          },
          backgroundColor: palette.primary[50]
        },
        '&.MuiAlert-standardSuccess': {
          '.MuiAlert-message': {
            color: palette.success[900]
          },
          '.MuiLink-root': {
            color: palette.success[900]
          },
          '.MuiSvgIcon-root': {
            color: palette.success[900]
          },
          backgroundColor: palette.success.light
        },
        '&.MuiAlert-standardWarning': {
          '.MuiAlert-message': {
            color: palette.warning.main
          },
          '.MuiLink-root': {
            color: palette.warning.main
          },
          '.MuiSvgIcon-root': {
            color: palette.warning.main
          },
          backgroundColor: palette.warning.light
        },
        '&.MuiAlert-toast': {
          '.MuiAlert-action': {
            padding: '0px'
          },
          '.MuiAlert-message': {
            alignItems: 'flex-start',
            display: 'flex',
            flexDirection: 'column'
          },
          '.MuiAlertTitle-root': {
            marginBottom: '4px'
          },
          '.MuiLink-root': {
            fontWeight: 400,
            margin: '4px 0 0 0'
          }
        },
        '&.MuiAlert-toastAttention': {
          '.MuiAlert-message': {
            color: palette.attention.main
          },
          '.MuiLink-root': {
            color: palette.attention.main
          },
          '.MuiSvgIcon-root': {
            color: palette.attention.main
          },
          backgroundColor: palette.attention.light
        },
        '&.MuiAlert-toastError': {
          '.MuiAlert-message': {
            color: palette.error[700]
          },
          '.MuiLink-root': {
            color: palette.error[700]
          },
          '.MuiSvgIcon-root': {
            color: palette.error[700]
          },
          backgroundColor: palette.error.light
        },
        '&.MuiAlert-toastInfo': {
          '.MuiAlert-message': {
            color: palette.info.dark
          },
          '.MuiLink-root': {
            color: palette.info.dark
          },
          '.MuiSvgIcon-root': {
            color: palette.info.dark
          },
          backgroundColor: palette.primary[50]
        },
        '&.MuiAlert-toastSuccess': {
          '.MuiAlert-message': {
            color: palette.success[900]
          },
          '.MuiLink-root': {
            color: palette.success[900]
          },
          '.MuiSvgIcon-root': {
            color: palette.success[900]
          },
          backgroundColor: palette.success.light
        },
        '&.MuiAlert-toastWarning': {
          '.MuiAlert-message': {
            color: palette.warning.main
          },
          '.MuiLink-root': {
            color: palette.warning.main
          },
          '.MuiSvgIcon-root': {
            color: palette.warning.main
          },
          backgroundColor: palette.warning.light
        },
        '&:has(.MuiSvgIcon-root)': {
          justifyContent: 'flex-start'
        },
        '.MuiAlert-icon': {
          padding: 0
        },
        '.MuiAlert-message': {
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'row',
          fontSize: '14px',
          fontWeight: 400,
          lineHeight: '22px',
          padding: 0
        },
        '.MuiAlertTitle-root': {
          fontSize: '14px',
          lineHeight: '22px',
          margin: '0 6px 0 0'
        },
        '.MuiIconButton-root': {
          marginRight: '12px',
          padding: 0
        },
        '.MuiLink-root': {
          ':hover': {
            backgroundColor: 'transparent',
            cursor: 'pointer'
          },
          fontSize: '14px',
          fontWeight: 600,
          lineHeight: '22px',
          marginLeft: '6px',
          textDecoration: 'underline'
        },
        '.MuiSvgIcon-root': {
          height: '24px',
          width: '24px'
        },
        borderRadius: '4px',
        justifyContent: 'center',
        maxWidth: '100%',
        padding: '8px 12px'
      }
    }
  };
}